/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonERP, SearchInput } from "@finanedi.es/storybook"
import { faFileExcel } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FetchDataRequest,
  FetchDataRequestImpuestosDetalle,
} from "api/AsientoContable.service"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { Dispatch, useState } from "react"
import { useTranslation } from "react-i18next"

const FilterMenuModeloAnual = ({
  serviceQuery,
  resetPagination,
  handleDownload,
  handleDownloadPerceptores,
  modelo,
}: {
  serviceQuery: Dispatch<Partial<FetchDataRequestImpuestosDetalle>>
  resetPagination: () => void
  handleDownload: () => void
  handleDownloadPerceptores?: () => void
  modelo?: number
}) => {
  const { t } = useTranslation()
  const [keyword, setKeyword] = useState("")
  const queryFixer = (queryParams: FetchDataRequest) => {
    const facturasParams = {
      Anyo: queryParams.Anyo,
      Keyword: queryParams.Keyword,
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(facturasParams).filter(([_key, value]) => value) // eslint-disable-line @typescript-eslint/no-unused-vars
    )
    return fixedQueryParams
  }

  const handleSearchInputChange = (ev: string) => {
    resetPagination?.()
    setKeyword(ev)
    serviceQuery(queryFixer({ Keyword: ev }))
  }

  return (
    <div className='tw-flex tw-flex-col sm:tw-flex-row tw-w-full lg:tw-w-fit tw-gap-3'>
      <SearchInput
        placeholder={`${t("taxSummary.detail.search")}`}
        onChange={(ev: string) => {
          handleSearchInputChange(ev)
        }}
        inputValue={keyword}
        className='tw-mb-1 sm:tw-mb-0 tw-h-10 tw-w-full sm:tw-w-72'
      />
      <ButtonERP
        onClick={handleDownload}
        icon={<FontAwesomeIcon icon={faFileExcel} />}
        customize={{
          type: "primary",
          size: "md",
        }}
        label={`${
          modelo === MODELO_IMPUESTO.MODELO_347
            ? t("taxSummary.detail.export")
            : t("taxSummary.detail.exportAccounting")
        }`}
      />
      {modelo !== MODELO_IMPUESTO.MODELO_347 ? (
        <ButtonERP
          onClick={handleDownloadPerceptores}
          icon={<FontAwesomeIcon icon={faFileExcel} />}
          customize={{
            type: "primary",
            size: "md",
          }}
          label={`${t("taxSummary.detail.exportPerceivers")}`}
        />
      ) : null}
    </div>
  )
}

export default FilterMenuModeloAnual
